var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 18,
    viewBox: "0 0 7 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59742 9.57702C5.59742 9.65179 5.57072 9.71588 5.51731 9.76929L1.33546 13.9511C1.28205 14.0045 1.21796 14.0312 1.14319 14.0312C1.06842 14.0312 0.998988 14.0045 0.934899 13.9511L0.486271 13.5025C0.422182 13.4384 0.390137 13.369 0.390137 13.2942C0.390137 13.2194 0.422182 13.15 0.486271 13.0859L3.99518 9.57702L0.486271 6.05209C0.422182 5.99868 0.390137 5.93459 0.390137 5.85982C0.390137 5.78505 0.422182 5.71562 0.486271 5.65153L0.934899 5.2029C0.988307 5.13881 1.05774 5.10677 1.14319 5.10677C1.22864 5.10677 1.29273 5.13881 1.33546 5.2029L5.51731 9.36873C5.57072 9.42214 5.59742 9.49157 5.59742 9.57702Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.72,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.390137 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right-arrow.6a51f8bd4ce7f700c8ecb9cd0095defc.svg";
export { ForwardRef as ReactComponent };